/**
 * 正则表达式
 */
export default class RE {
  public static readonly Client = { // 客户端
    Mobile: /Mobile|Phone|webOS|iPod|iPad|iPhone|Android|SymbianOS|BlackBerry|Windows CE|Windows Mobile|Windows Phone/i, // 移动端
    PC: /Windows|Mac|Linux/i // 主机端
  };
  public static readonly System = { // 系统
    iOS: /\(i[^;]+;( U;)? CPU.+Mac OS X\)/i, // iOS
    Android: /Android|Adr/i, // 安卓
    SymbianOS: /SymbianOS/i, // 塞班
    BlackBerry: /BlackBerry/i, // 黑莓
    Huawei: /Huawei/i, // 华为
    WindowsCE: /Windows CE/i, // 微软掌上PC
    WindowsPhone: /Windows Mobile|Windows Phone/i, // 微软手机
    Windows: /Windows/i, // Windows
    Mac: /Mac/i, // Mac
    Linux: /Linux/i // Linux
  };
  public static readonly Browser = { // 浏览器
    QQWeb: /MQQBrowser/i, // QQ
    QQ: /QQ/i, // QQ内置浏览器
    WeChat: /MicroMessenger/i, // 微信内置浏览器
    WeiBo: /WeiBo/i, // 微博内置浏览器
    UC: /UCBrowser/i, // UC
    Firefox: /Firefox/i, // 火狐
    Opera: /Opera/i, // 欧朋
    Chrome: /Chrome/i, // 谷歌
    Safari: /Safari/i, // Safari
    Edge: /Edge/i, // Edge
    IE: /MSIE/i // IE
  };
  public static readonly Format = { // 格式
    NoSpace: /^\S*$/, // 不可有空格
    W: /^\w*$/, // 支持数字、英文大小写、下划线
    NEC: /^[0-9a-zA-Z\u4E00-\u9FA5]*$/, // 支持数字、英文大小写、中文
    NE: /^[0-9a-zA-Z]*$/, // 支持数字、英文大小写
    N: /^[0-9]*$/, // 支持数字
    E: /^[a-zA-Z]*$/, // 支持英文大小写
    ESmall: /^[a-z]*$/, // 支持英文小写
    EBig: /^[A-Z]*$/, // 支持英文大写
    C: /^[\u4E00-\u9FA5]*$/, // 支持中文
    CAll: /^[\u4E00-\u9FA5\u9FA6-\u9FCB\u3400-\u4DB5]*$/, // 支持中文（包含生僻字）
    Phone: /^1[3456789]\d{9}$/, // 手机
    Mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, // 邮箱
    IPV4: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/ // IPV4
  };
  public static readonly Color = { // 颜色
    HEX: /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/, // 16进制
    RGB: /^[rR][gG][Bb]\(([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){3}[\\s]*(1|1.0|0|0.[0-9])[\\s]*\)$/, // RGB
    RGBA: /^[rR][gG][Bb][Aa]\(([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){3}[\\s]*(1|1.0|0|0.[0-9])[\\s]*\)$/, // RGBA
    HSL: /^[hH][Ss][Ll]\(([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*)\)$/, // HSL
    HSLA: /^[hH][Ss][Ll][Aa]\(([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,){2}([\\s]*(1|1.0|0|0.[0-9])[\\s]*)\)$/, // HSLA
  };
  public static readonly Server = { // 服务器
    All: /\.*/i // 全部
  };
}